import { ArrowLeft, Save, Undo2, Redo2, Grid3x3, Magnet, Database, Printer, Loader2, ZoomIn, ZoomOut, Crosshair } from "lucide-react";

const ZOOMS = [0.5, 0.75, 1, 1.25, 1.5, 2, 2.5];

const Toggle = ({ on, onClick, children, testId, title }) => (
  <button onClick={onClick} title={title} data-testid={testId}
    className={`h-8 w-8 grid place-items-center rounded-md transition-colors ${on ? "bg-amber-500/15 text-amber-300" : "text-slate-400 hover:text-white hover:bg-slate-800"}`}>{children}</button>
);

export default function EditorHeader({ tpl, side, setSide, zoom, setZoom, snap, setSnap, guides, setGuides, smart, setSmart, dirty, saving, onSave, onUndo, onRedo, onRename, goTo }) {
  const zi = ZOOMS.indexOf(zoom);
  return (
    <header className="h-14 shrink-0 bg-slate-950 border-b border-slate-800 px-3 flex items-center gap-3 z-40">
      <button onClick={() => goTo("/")} className="h-8 w-8 grid place-items-center rounded-md text-slate-400 hover:text-white hover:bg-slate-800" data-testid="editor-back-button" title="Back to dashboard">
        <ArrowLeft size={17} />
      </button>
      <input value={tpl.name} onChange={(e) => onRename(e.target.value)} data-testid="design-name-input"
        className="bg-transparent font-heading font-bold text-sm px-2 h-8 rounded-md border border-transparent hover:border-slate-800 focus:border-slate-600 outline-none w-56" />
      <span className="text-[11px] font-mono text-slate-500 hidden xl:block">{tpl.width}×{tpl.height}mm</span>
      {dirty && <span className="text-[10px] font-mono text-amber-400" data-testid="unsaved-indicator">● unsaved</span>}

      <div className="mx-auto flex items-center gap-1 bg-slate-900 border border-slate-800 rounded-lg p-1" data-testid="side-toggle">
        {["front", "back"].map((s) => (
          <button key={s} onClick={() => setSide(s)} data-testid={`side-toggle-${s}`}
            className={`px-4 h-7 rounded-md text-xs font-semibold capitalize transition-colors ${side === s ? "bg-slate-700 text-white" : "text-slate-400 hover:text-white"}`}>{s}</button>
        ))}
      </div>

      <div className="flex items-center gap-1">
        <Toggle onClick={onUndo} testId="undo-button" title="Undo (Ctrl+Z)"><Undo2 size={16} /></Toggle>
        <Toggle onClick={onRedo} testId="redo-button" title="Redo (Ctrl+Shift+Z)"><Redo2 size={16} /></Toggle>
        <span className="w-px h-5 bg-slate-800 mx-1" />
        <Toggle onClick={() => zi > 0 && setZoom(ZOOMS[zi - 1])} testId="zoom-out-button" title="Zoom out"><ZoomOut size={16} /></Toggle>
        <span className="text-[11px] font-mono w-11 text-center text-slate-300" data-testid="zoom-level">{Math.round(zoom * 100)}%</span>
        <Toggle onClick={() => zi < ZOOMS.length - 1 && setZoom(ZOOMS[zi + 1])} testId="zoom-in-button" title="Zoom in"><ZoomIn size={16} /></Toggle>
        <Toggle on={guides} onClick={() => setGuides(!guides)} testId="toggle-guides" title="Safe-zone guides"><Grid3x3 size={16} /></Toggle>
        <Toggle on={smart} onClick={() => setSmart(!smart)} testId="toggle-smart-guides" title="Smart alignment guides"><Crosshair size={16} /></Toggle>
        <Toggle on={snap} onClick={() => setSnap(!snap)} testId="toggle-snap" title="Snap to 0.5mm grid"><Magnet size={16} /></Toggle>
        <span className="w-px h-5 bg-slate-800 mx-1" />
        <button onClick={onSave} disabled={saving} className="cf-btn-ghost h-8 text-xs" data-testid="save-template-button">
          {saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Save
        </button>
        <button onClick={() => goTo(`/data/${tpl.id}`)} className="cf-btn-ghost h-8 text-xs" data-testid="open-data-button">
          <Database size={14} /> Data
        </button>
        <button onClick={() => goTo(`/print/${tpl.id}`)} className="cf-btn-primary h-8 text-xs px-3" data-testid="export-open-studio-button">
          <Printer size={14} /> Print / Export
        </button>
      </div>
    </header>
  );
}
